import React from 'react'
import BrandFormBase from './BrandFormBase'

const AddBrandForm: React.FC = () => {
  return <BrandFormBase isEditMode={false} />
}

export default AddBrandForm
